import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import SecondaryButton from '../FormFields/SecondaryButton';

function PriceCell(props) {
  const wrapperClass = "text-center text-sm px-2 py-1 whitespace-no-wrap border-t border-cruise_darkblue-30 hover:bg-cruise_darkblue-10 ";

  return (!props.price
    ? <td className={wrapperClass + " text-cruise_darkblue-30"}>
      <div>N/A</div>
    </td>
    :
    <td className={wrapperClass } >
      <React.Fragment>
        {props.selectable ?
          <SecondaryButton className="w-48"
            onClick={props.handleSelection}
            selected={props.selected}
            buttonText={
              <NumberFormat className="px-1"
                value={props.price}
                displayType={'text'} decimalSeparator={','} thousandSeparator={'.'}
                suffix=",-"
              />
            }
          >
          </SecondaryButton>
          :
          <div className={props.priceClass}>
            <NumberFormat className="p-3"
              value={props.price}
              displayType={'text'} decimalSeparator={','} thousandSeparator={'.'}
              suffix=",-"
            />
          </div>
        }
      </React.Fragment>
    </td>
  )
}

PriceCell.propTypes = {
  price: PropTypes.number,
  cabintype: PropTypes.string,
  priceClass: PropTypes.string,
  handleSelection: PropTypes.func,
  selectable: PropTypes.bool,
}

PriceCell.defaultProps = {
  selectable: true,
}

export default PriceCell;